import { BlockColor } from "./enums";

export const BlockColorMap = {
  [BlockColor.BLUE]: "bg-storyblok-blue",
  [BlockColor.ORANGE]: "bg-storyblok-orange",
  [BlockColor.PURPLE]: "bg-storyblok-purple",
};

export const BulletpointColorMap = {
  [BlockColor.BLUE]: "[&_li]:before:bg-storyblok-blue",
  [BlockColor.ORANGE]: "[&_li]:before:bg-storyblok-orange",
  [BlockColor.PURPLE]: "[&_li]:before:bg-storyblok-purple",
};
